import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Icon from '@autobest-ui/icon';
import { Drawer } from '@autobest-ui/components';
import { withRouter, RouteComponentProps } from 'react-router';
import Container from '../container';
import { getOfficialAssetUrl } from '../../utils/resource';
import { HomeUrl } from '../../constants/url';
import { NavActiveFindList, navList } from './constants';
import './index.scss';

interface AutobestUSAHeaderState {
  drawerVisible: boolean;
  navActiveIndex: number;
}

class Header extends React.Component<
  RouteComponentProps,
  AutobestUSAHeaderState
> {
  readonly prefixCls = 'header';

  constructor(props) {
    super(props);

    this.state = {
      drawerVisible: false,
      navActiveIndex: this.getNavActiveIndex()
    };
  }

  componentDidUpdate(prevProps: RouteComponentProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      const navActiveIndex = this.getNavActiveIndex();
      if (navActiveIndex !== this.state.navActiveIndex) {
        this.setState({
          navActiveIndex
        });
      }
    }
  }

  getNavActiveIndex = () => {
    return NavActiveFindList.findIndex(item =>
      item.includes(this.props.location.pathname)
    );
  };

  onOpenDrawer = () => {
    this.setState(prevState => ({
      drawerVisible: !prevState.drawerVisible
    }));
  };

  onCloseDrawer = () => {
    if (this.state.drawerVisible) {
      this.setState({
        drawerVisible: false
      });
    }
  };

  renderNavList = () => {
    const cls = this.prefixCls;
    const { navActiveIndex } = this.state;
    return navList.map((item, index) => (
      <li
        key={item.name}
        className={classNames({
          [`${cls}-other`]: item.isOther,
          [`${cls}-active`]: navActiveIndex === index
        })}
      >
        <Link onClick={this.onCloseDrawer} to={item.url}>
          {item.name}
        </Link>
      </li>
    ));
  };

  render() {
    const cls = this.prefixCls;
    const { drawerVisible } = this.state;

    return (
      <header className={cls}>
        <div className={`${cls}-top flex-row`}>
          <Container className="flex-row row-between">
            <div className="flex-row">
              <Icon
                name="menu"
                className={`${cls}-menu`}
                onClick={this.onOpenDrawer}
              />
              <Link className={`${cls}-logo-l`} to={HomeUrl}>
                <img src={getOfficialAssetUrl('/default/logo.svg')} />
              </Link>
            </div>
            <img
              className={`${cls}-logo-r`}
              src={getOfficialAssetUrl('/default/header-oe-supplier.png')}
            />
          </Container>
        </div>
        <Container>
          <ul className={`${cls}-nav flex-row`}>{this.renderNavList()}</ul>
        </Container>
        <Drawer
          className={`${cls}-drawer`}
          visible={drawerVisible}
          width="3rem"
          onClose={this.onCloseDrawer}
        >
          <ul className={`${cls}-d-nav`}>{this.renderNavList()}</ul>
        </Drawer>
      </header>
    );
  }
}

export default withRouter(Header);
